import { SCREEN_NAME, CLICK_ACTIONS, IMPRESSION_ACTIONS, BILL_IMAGE_HALF_CARD_LABELS } from "../constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const billUploadHalfCardImpressionEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    context?: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT,
        action: IMPRESSION_ACTIONS.IMPRESSION_BILL_IMAGE_HALF_CARD,
        label: BILL_IMAGE_HALF_CARD_LABELS.PROCEED,
        context,
    });
};

export const billUploadHalfCardProceedClickEvent = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    context?: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT,
        action: CLICK_ACTIONS.CLICK_BILL_IMAGE_HALF_CARD_PROCEED,
        label: BILL_IMAGE_HALF_CARD_LABELS.PROCEED,
        context,
    });
};

export const billUploadHalfCardDenyClickEvent = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    context?: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT,
        action: CLICK_ACTIONS.CLICK_BILL_IMAGE_HALF_CARD_DENY,
        label: BILL_IMAGE_HALF_CARD_LABELS.DENY,
        context,
    });
};

export const billUploadHalfCardCloseClickEvent = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    context?: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT,
        action: CLICK_ACTIONS.CLICK_BILL_IMAGE_HALF_CARD_CLOSE,
        label: BILL_IMAGE_HALF_CARD_LABELS.CLOSE,
        context,
    });
};
